import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const initialForm = {
  prenume: "",
  nume: "",
  email: "",
  numar_telefon: "",
  oras: "",
  judet: "",
  tara: "România",
  nume_petitie: "",
  timestamp: new Date().toISOString(),
};

const AddPetitionModal = ({ show, onHide, onSave, initialData }) => {
  const [form, setForm] = useState(initialForm);

  useEffect(() => {
    if (initialData) {
      setForm(initialData);
    } else {
      setForm(initialForm);
    }
  }, [initialData, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    onSave(form);
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
          {initialData ? "Editează Semnătură" : "Adaugă Semnătură"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <div className="row">
            {[
              "prenume",
              "nume",
              "email",
              "numar_telefon",
              "oras",
              "judet",
              "nume_petitie",
            ].map((field) => (
              <div className="col-md-6 mb-3" key={field}>
                <Form.Label>
                  {field
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (l) => l.toUpperCase())}
                </Form.Label>
                <Form.Control
                  type="text"
                  name={field}
                  value={form[field]}
                  onChange={handleChange}
                />
              </div>
            ))}

            <div className="col-md-6 mb-3">
              <Form.Label>Țara</Form.Label>
              <Form.Select name="tara" value={form.tara} onChange={handleChange}>
                <option value="România">România</option>
                <option value="Altă țară">Altă țară</option>
              </Form.Select>
            </div>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Închide
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Salvează
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddPetitionModal;
